import { render, staticRenderFns } from "./SvgTest.vue?vue&type=template&id=2a59bca2&"
import script from "./SvgTest.vue?vue&type=script&lang=js&"
export * from "./SvgTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports